import { Window } from "@progress/kendo-react-dialogs";
import {
  fieldFocusIndex,
  selectedFieldPropertyValues,
  selectedSectionName,
  templateData,
} from "../../Template/NewTemplateSignals";
import GalleryConstructor from "./GalleryConstructor";
import {
  galSessionData,
  galleryConstructorVisibility,
  selectedFieldName,
} from "./GalleryConstructorSignals";

export const GalleryConstructorWindow = () => {
  const handlePropertyChange = ({ propName, propValue }) => {
    if (fieldFocusIndex.value === null) {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              properties: {
                ...section.properties,
                [propName]: propValue,
              },
            };
          }
          return section;
        }),
      };
    } else {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              fields: section.fields.map((field) => {
                if (field.fieldName === selectedFieldName.value) {
                  return {
                    ...field,
                    properties: {
                      ...field.properties,
                      [propName]: propValue,
                    },
                  };
                }
                return field;
              }),
            };
          }
          return section;
        }),
      };
    }
  };

  return (
    <>
      {galleryConstructorVisibility.value && (
        <Window
          key="field-constructor-window"
          onClose={() => {
            galleryConstructorVisibility.value = !galleryConstructorVisibility.value;
            galSessionData.value = [];
          }}
          title={"Gallery Constructor"}
          width={1200}
          height={800}
        >
          <GalleryConstructor
            handlePropertyChange={handlePropertyChange}
            properties={
              selectedFieldPropertyValues.value?.Fields || [
                {
                  id: 0,
                  fieldName: "",
                  fieldType: "",
                  properties: {},
                  selected: false,
                },
              ]
            }
            currentPropertyValues={selectedFieldPropertyValues.value}
          />
        </Window>
      )}
    </>
  );
};
